import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import ServiceScheduleCreate from './ServiceScheduleCreate';
import { Moment } from 'moment';

interface Props extends BaseModalProps {
	selectedDate: Moment;
	resourceId: string;
	onSuccess: () => void;
}

const ServiceScheduleCreateModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='base.createShiftsSchedule'>
			<ServiceScheduleCreate
				selectedDate={props.selectedDate}
				resourceId={props.resourceId}
				onSuccess={props.onSuccess}
			/>
		</BaseModal>
	);
};

export default ServiceScheduleCreateModal;
